import React, { FC, useState } from 'react';

import { gridTheme } from '@utils/grid';
import { Price as PriceType } from 'shared-types/Common';
import { useIsWindowWiderThan } from '../../../hooks/useIsWindowWiderThan';
import { NarrowLayout, WideLayout } from './layouts';
import { PricingTypeEnum } from './layouts/shared/PricingType';
import { isArray } from 'lodash';

type ExtraProps = {
  price: PriceType;
  pricePerNight?: PriceType;
  description: string;
  featured: boolean;
  image: { url: string; externalKey?: string };
  isSelected: boolean;
  name: string;
  showPrice: boolean;
  controls: JSX.Element;
  pricingType?: PricingTypeEnum;
  quantityLabel?: string | null;
};

export const Extra: FC<ExtraProps> = ({
  price,
  pricePerNight,
  description,
  featured,
  image: images,
  isSelected,
  name,
  showPrice,
  controls,
  pricingType,
  quantityLabel,
}) => {
  const [isShowingDetails, setShowingDetails] = useState(false);
  const showDetails = () => setShowingDetails(true);
  const hideDetails = () => setShowingDetails(false);
  const isWiderViewport = useIsWindowWiderThan(gridTheme.breakpoints.md);

  const Layout = isWiderViewport ? WideLayout : NarrowLayout;
  const image = isArray(images) ? images?.[0]?.url : images?.url;
  return (
    <Layout
      description={description}
      featured={featured}
      hideDetails={hideDetails}
      imageUrl={image}
      isSelected={isSelected}
      isShowingDetails={isShowingDetails}
      name={name}
      price={price}
      pricePerNight={pricePerNight}
      showDetails={showDetails}
      showPrice={showPrice}
      controls={controls}
      pricingType={pricingType}
      quantityLabel={quantityLabel}
    />
  );
};
